import { Mail, MapPin, Star, Users, ShoppingBag } from "lucide-react";

const BRAND_LOGO =
  "https://customer-assets.emergentagent.com/job_journey-hub-283/artifacts/6ld7fx8l_file_00000000ae8871f5b0415f16ffc8ce51~2.png";

const STATS = [
  ["50", "States."],
  ["NO", "Repeats."],
  ["ALL", "Vibes."],
  ["1", "Live route."],
];

const PILLARS = [
  { icon: <MapPin />, title: "Travel", body: "50 states, no repeats." },
  { icon: <Star />, title: "Content", body: "Stories, reels, dispatches from the road." },
  { icon: <Users />, title: "Community", body: "City meetups + a private VIP channel." },
  { icon: <ShoppingBag />, title: "Brand Partners", body: "Sponsors who stop traffic." },
];

export default function PressHero() {
  return (
    <>
      <section className="relative grain splatter overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-8 pt-16 pb-20 grid md:grid-cols-12 gap-10 items-center relative z-10">
          <div className="md:col-span-7">
            <div className="overline">Press kit · Sponsor deck</div>
            <h1 className="font-display text-6xl md:text-8xl uppercase mt-3 leading-[0.85] drip-shadow">
              Bold. <span className="text-[#FF1E1E]">Unapologetic.</span>
              <br />
              Unforgettable.
            </h1>
            <p className="font-script text-3xl md:text-4xl mt-6 text-white/90">
              A brand that stops traffic.
            </p>
            <p className="text-white/75 mt-7 text-lg max-w-2xl">
              FMAA — <span className="text-white font-semibold">FuelMeh Across America</span> — is a
              lifestyle travel brand built around a 50-state journey that blends content creation,
              audience engagement, and bold roadside storytelling. We turn everyday travel moments
              into shareable, entertaining experiences while partnering with brands along the way.
            </p>
            <a
              href="#contact"
              className="btn-blaze mt-8 inline-flex"
              data-testid="press-hero-cta"
            >
              <Mail size={14} /> Start a partnership
            </a>
          </div>
          <div className="md:col-span-5">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-[#FF1E1E]/30 via-transparent to-[#FFC107]/20 blur-3xl" />
              <img
                src={BRAND_LOGO}
                alt="FMAA primary lockup"
                className="relative w-full max-w-[460px] mx-auto border border-white/10"
                data-testid="press-brand-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="border-y border-white/10 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-10 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {STATS.map(([n, l]) => (
            <div key={l}>
              <div className="font-display text-5xl md:text-6xl text-[#FF1493] drip-shadow">{n}</div>
              <div className="text-white/70 mt-1 uppercase tracking-[0.25em] text-xs font-mono-tactical">{l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Pillars */}
      <section className="max-w-7xl mx-auto px-6 md:px-8 py-16">
        <div className="overline">The four pillars</div>
        <h2 className="font-display text-4xl md:text-5xl uppercase mt-3">What FMAA delivers</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
          {PILLARS.map((p) => (
            <div key={p.title} className="tac-card p-7" data-testid={`press-pillar-${p.title.toLowerCase()}`}>
              <span className="text-[#FF1493]">{p.icon}</span>
              <h3 className="font-display text-2xl uppercase mt-5">{p.title}</h3>
              <p className="text-white/70 text-sm mt-3">{p.body}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
